/**
 * Rotación del mapa — ADAPTADOR AISLADO A PROPÓSITO.
 *
 * ⚠️ BLOQUEANTE LEGAL ANTES DE DESPLEGAR ⚠️
 *
 * La implementación actual usa `leaflet-rotate`, que es **GPL-3.0**. En
 * creaPlanos se tomó la decisión explícita de NO adoptar copyleft en una
 * herramienta propietaria de VitalHeart, y la rotación se resolvió a mano con
 * una transformación CSS sobre el marco del mapa. Este repo hereda el plugin del
 * HTML original y por eso arrastra el mismo problema.
 *
 * Todo el acoplamiento al plugin vive en este archivo. Reemplazarlo por la
 * rotación propia es reescribir estas funciones, sin tocar el resto del código.
 *
 * Convención de rumbo (la misma que usa creaPlanos, para que ambos sistemas no
 * se contradigan): **el rumbo es lo que apunta hacia arriba**. Rumbo 90 pone el
 * este arriba. Como `rotate()` de CSS es horario y la imagen se rota antihorario,
 * una implementación propia tiene que aplicar `rotate(-bearing)`.
 *
 * Ver docs/hallazgos.md § Rotación.
 */

/** Opciones de rotación para el constructor de Leaflet. */
export const rotationMapOptions = {
  rotate: true,
  touchRotate: true,
  shiftKeyRotate: true,
  rotateControl: { closeOnZeroBearing: false },
};

/** ¿El mapa soporta rotación? Falso si se quitó el plugin y aún no hay reemplazo. */
export function supportsRotation(map) {
  return typeof map.setBearing === 'function';
}

/** Aplica un rumbo en grados. Sin soporte de rotación es un no-op silencioso. */
export function setBearing(map, degrees) {
  const bearing = Number.parseFloat(degrees) || 0;
  if (supportsRotation(map)) map.setBearing(bearing);
  return bearing;
}

/** Rumbo actual en grados. Cero si no hay rotación disponible. */
export function getBearing(map) {
  return typeof map.getBearing === 'function' ? map.getBearing() : 0;
}
